import { render, staticRenderFns } from "./principal-batch.vue?vue&type=template&id=af151462&scoped=true"
import script from "./principal-batch.vue?vue&type=script&lang=ts"
export * from "./principal-batch.vue?vue&type=script&lang=ts"
import style0 from "./principal-batch.vue?vue&type=style&index=0&id=af151462&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af151462",
  null
  
)

export default component.exports